import React, { useState, useEffect } from "react";

import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';

import { Grid, Tabs, Tab, AppBar, IconButton, makeStyles, Divider } from "@material-ui/core";

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import BasicInfo from "./BasicInfo";
import SecurityAccess from "./SecurityAccess";
import { Loader } from "../../components/loader";
import { fetchPrivilegeSupport, hasAbility } from '../../utility/AbilityCheck';

import { getMembersList, clearReduxDataOfCurrentComponent, getRolesMembers, getGroups, createMember, terminateMember } from '../../store/actions';
import { getOrgId } from '../../utility/utils';

const useStyles = makeStyles((theme) => ({
	tabController: {
		"& .MuiTab-textColorInherit ": {
			minWidth: "0px"
		}
	},
	appBar: {
		boxShadow: "none !important"
	},
	ContactTabs: {
		marginTop: 'none !important',
		marginBottom: 'none !important',
		border: "3px solid #eeee",
	},
	paper: {
		width: '100%',
		// marginBottom: theme.spacing(2),
		border: "3px solid #eeee",
		marginLeft: '-41px !important'
	},
	backIconCls: {
		padding: '0px !important'
	}
}))

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const AddMember = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { isNewV1Theme } = props;
    const { chartUniqueId, chartData } = props.data

	const [validate, setValidate] = useState({})
	const [membersRoles, setMembersRoles] = useState()
	const [membersGroup, setMembersGroup] = useState()
	const [membersList, setMembersList] = useState([])
	const [memberDetails, setMemberDetails] = useState({})
	const [fianlFormData, setFinalFormData] = useState({})

	const [previlageData, setPrevilageData] = useState("")
	// Generate abilities based on privileges
	const [ability, setAbility] = useState(null);
	const [userHasAbility, setUserHasAbility] = useState(false);

	useEffect(() => {
		if (props.match.params.id !== 'new') {
			fetchMemberData()
			fetchData()
		} else {
			setMemberDetails({})
			fetchData()
		}
	}, [])

	const fetchMemberData = () => {
		Promise.all([
			props.getMembersList({
				appId: props.appId,
				dataUniqueId: chartUniqueId + "_member",
				id: props.match.params.id
			})
		].filter(Boolean))
	}

    const fetchData = () => {
        const orgId = getOrgId(props);
        Promise.all([
            props.getRolesMembers({
                appId: props.appId,
                dataUniqueId: chartUniqueId + "_member_roles",
                orgId
            }),
            props.getGroups({
                appId: props.appId,
                dataUniqueId: chartUniqueId + "_member_groups",
                orgId
            })
        ].filter(Boolean))
    }

	useEffect(() => {
		if (props.formData?.document && props.formData.document[chartUniqueId + "_member"]) {
			let memObj = props.formData.document[chartUniqueId + "_member"]
			let obj = {
				"firstName": memObj.firstName ? memObj.firstName : memObj.name?.split(" ")[0],
				"lastName": memObj.lastName ? memObj.lastName : memObj.name?.split(" ")[1],
				"_id": memObj._id,
				"email": memObj.email,
				"status": memObj.status,
				// "phone": memObj.phone,
				"roles": memObj.roles?.map(item => ({ label: item.name, value: item.id })),
				"groups": memObj.groups?.map(item => ({ label: item.name, value: item.id })),
				"isDisable": memObj.isDisable
			}
			if (memObj?.supervisor?.id) {
				obj.supervisor = {
					id: memObj.supervisor.id,
					name: memObj.supervisor.name,
					label: memObj.supervisor.name,
					value: memObj.supervisor.id
				}
			}
			setFinalFormData({ ...fianlFormData, ...obj })
			// setMemberDetails(obj)
			setValidate({
				"firstName": obj.firstName ? false : true,
				"lastName": obj.lastName ? false : true,
				"email": obj.email ? false : true,
				// "phone": obj.phone ? false : true
			})
		}
	}, [props.formData?.document?.[chartUniqueId + "_member"]])

	useEffect(() => {
		if (props.formData.document?.[chartUniqueId + "_member_roles"]) {
			let memRoles = props.formData.document[chartUniqueId + "_member_roles"]?.map(item => ({ label: item.description, value: item._id }))
			setMembersRoles(memRoles)
			// setFinalFormData({...fianlFormData,memRoles})		
		}
	}, [props.formData?.document?.[chartUniqueId + "_member_roles"]])

	useEffect(() => {
		if (props.formData.document?.[chartUniqueId + "_member_groups"]) {
			let memGroup = props.formData.document[chartUniqueId + "_member_groups"]?.map(item => ({ label: item.description, value: item._id }))
			setMembersGroup(memGroup)
			// setFinalFormData({...fianlFormData,memGroup})			
		}
	}, [props.formData?.document?.[chartUniqueId + "_member_groups"]])

	useEffect(() => {
		if (props.formData.document?.[chartUniqueId + "_members"]?.length) {
			let membersListData = props.formData?.document[chartUniqueId + "_members"].map(k => ({
				id: k._id,
				name: (k.name || (k.firstName + k.lastName)),
				value: k._id,
				label: (k.name || (k.firstName + k.lastName))
			}))
			setMembersList(membersListData)
		}
	}, [props.formData?.document?.[chartUniqueId + "_members"]])

    useEffect(() => {
        if (props.formData.document?.[chartUniqueId + "_members"]?.length) {
        } else {
            props.getMembersList({
                appId: props.appId,
                orgId: getOrgId(props),
                dataUniqueId: chartUniqueId + "_members"
            })
        }
    }, [])

	// Member Privileges code end here
	useEffect(() => {
		const { privilegeData, ability } = fetchPrivilegeSupport(props, chartData);
		setPrevilageData(privilegeData);
		setAbility(ability);
		setUserHasAbility(hasAbility(ability));
	}, [
		props.formData.document[`${props.match.params.appid}_memberprivileges`],
		props?.privilegesSupport,
		props.match.params.page,
		window.location.pathname,
		chartData?.selectedDataModel
	]);
	// Member Privileges code end here

	useEffect(() => {
		return () => {
			clearCurrentChartReduxStore()
			setMemberDetails({})
		}
	}, [])

	const clearCurrentChartReduxStore = () => {
		let subKeys = [
			chartUniqueId + "_member",
			chartUniqueId + "_member_roles",
			chartUniqueId + "_member_groups",
			chartUniqueId + '_create_member',
			chartUniqueId + '_terminate_member'
		]

		props.clearReduxDataOfCurrentComponent({
			key: "document",
			subKey: subKeys
		})
	}

	const handlesSaveFunctionality = (data) => {
		setFinalFormData({ ...fianlFormData, ...data })
	}

	const validator = (data) => {
		setValidate({ ...validate, ...data })
	}

	const handleBackBtnClick = () => {
		history.goBack()
	}

	if (props.formData[chartUniqueId + "_member_loading"] || props.formData[chartUniqueId + "_member_roles_loading"] || props.formData[chartUniqueId + "_member_groups_loading"]) {
		return <Loader />
	}

    return (
        <div style={{...( !isNewV1Theme && { position: 'absolute' }),}}>
            <div style={{ display: 'flex' }}>
                <IconButton onClick={handleBackBtnClick} className={classes.backIconCls} title={'Back'}>
                    { !isNewV1Theme && <ArrowBackIosIcon /> }
                </IconButton>
               {isNewV1Theme ? (fianlFormData?._id ? <h2>Edit User</h2> : <h2>Add User</h2>) :  <h1>{'User View'}</h1>}
            </div>
            { !isNewV1Theme && <Divider /> }
            <Grid container style={{ ...(isNewV1Theme ? { paddingTop: 16 } : { marginTop: 30,position: 'relative', overflow: 'visible' })}} >
                <BasicInfo
                    {...props}
                    memberDetails={memberDetails}
                    fianlFormData={fianlFormData}
                    membersRoles={membersRoles}
                    membersGroup={membersGroup}
                    membersList={membersList}
                    createMember={props.createMember}
                    terminateMember={props.terminateMember}
                    validator={validator}
                    validate={validate}
                    handlesSaveFunctionality={handlesSaveFunctionality}

                    // props related to privileges
                    previlageData={previlageData}
                    ability={ability}
                    userHasAbility={userHasAbility}
                    isNewV1Theme={isNewV1Theme}
                />
            </Grid>
        </div>);
};

const mapDispatchToProps = {
	getMembersList,
	clearReduxDataOfCurrentComponent,
	getRolesMembers,
	getGroups,
	createMember,
	terminateMember
}

const mapStateToProps = state => {
    return {
        formData: state.form,
        user: state.user,
        org: state.org,
        login: state.login,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddMember))